import React from 'react'
import { Link } from 'react-router'

import rqLogoUrl from '@/assets/img/logo.svg'
import compassLogoUrl from '@/assets/img/logo-compass.svg'
import icaewLogoUrl from '@/assets/img/logo-icaew.png'
import { useAuth } from '@/hooks/useAuth'
import { useHomeRoute } from '@/hooks/useHomeRoute'

const logoClassName = 'h-7 w-auto object-contain'

const LogoAndMenuToggleButton: React.FC = () => {
  const homeRoute = useHomeRoute()
  const { isIcaewUser, isClientUser } = useAuth()

  function renderLogo() {
    if (isIcaewUser) {
      return <img src={icaewLogoUrl} alt="RQ ICAEW" className={logoClassName} />
    }

    if (isClientUser) {
      return (
        <img src={compassLogoUrl} alt="Compass" className={logoClassName} />
      )
    }

    return <img src={rqLogoUrl} alt="RQ" className={logoClassName} />
  }

  return (
    <div
      className="flex items-center justify-between gap-2 px-3 py-2
        group-data-[collapsible=icon]:flex-col
        group-data-[collapsible=icon]:justify-center
        group-data-[collapsible=icon]:gap-2 group-data-[collapsible=icon]:px-0"
    >
      <Link to={homeRoute} className="block shrink-0">
        {renderLogo()}
      </Link>
    </div>
  )
}

export default LogoAndMenuToggleButton
